export interface GetCurrencyConversionListPagingAndFilterResponse {
    isSuccess: boolean
    message: any
    data: GetCurrencyConversionListPagingAndFilterResponseData
}

export interface GetCurrencyConversionListPagingAndFilterResponseData {
    items: GetCurrencyConversionListPagingAndFilterResponseItem[]
    totalRecordCount: number
}

export interface GetCurrencyConversionListPagingAndFilterResponseItem {
    currencyConversionId: string
    date: string
    dateStr: string
    realDate: string
    fromCurrencyId: string
    toCurrencyId: string
    fromCurrencyName: string
    toCurrencyName: string
    buy: number
    buyStr: string
    sell: number
    sellStr: string
    isFromIntegration: boolean
    isCustomActive: boolean
    createdDate: string
    createdUser: string
    updatedDate: string
    updatedUser: string
    isSelected: boolean
}

export const initialGetCurrencyConversionListPagingAndFilterResponseData: GetCurrencyConversionListPagingAndFilterResponseData = {
    items: [],
    totalRecordCount: 0
}